import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, of, switchMap, tap } from 'rxjs';

import { ToastService } from '@ps/core-overlay';
import { EffectsBase } from '@ps/core-data-access';

import { OperatorSettingsService } from '../../../services/operator-settings.service';
import { OperatorSettingsCurrencyActions } from './currency.actions';

@Injectable()
export class OperatorSettingsCurrencyEffects extends EffectsBase {
  private readonly _actions$ = inject(Actions);
  private readonly _service = inject(OperatorSettingsService);
  private readonly _toast = inject(ToastService);

  public readonly loadCurrencies$ = createEffect(() =>
    this._actions$.pipe(
      ofType(OperatorSettingsCurrencyActions.loadCurrencies),
      switchMap(() =>
        this._service.getAllCurrencies().pipe(
          map((currencies) =>
            OperatorSettingsCurrencyActions.loadCurrenciesSuccess({
              currencies,
            }),
          ),
          this.psCatchError(
            (error) =>
              of(
                OperatorSettingsCurrencyActions.loadCurrenciesFailure({
                  error: error.message,
                }),
              ),
            { notify: true },
          ),
        ),
      ),
    ),
  );

  public readonly updateCurrency$ = createEffect(() =>
    this._actions$.pipe(
      ofType(OperatorSettingsCurrencyActions.updateCurrency),
      switchMap(({ currencyShortCode, data }) =>
        this._service.updateCurrency(currencyShortCode, data).pipe(
          tap(() => this._toast.success('Currency updated successfully')),
          map(() =>
            OperatorSettingsCurrencyActions.updateCurrencySuccess({
              currencyShortCode,
              fx: data.fx,
              crRate: data.crRate,
              symbol: data.symbol,
            }),
          ),
          this.psCatchError(
            (error) =>
              of(
                OperatorSettingsCurrencyActions.updateCurrencyFailure({
                  error: error.message,
                }),
              ),
            { notify: true },
          ),
        ),
      ),
    ),
  );
}
